module.exports = __webpack_public_path__ + "img/default.b1febeea.png";